import { render } from "./horizontal-nav.vue?vue&type=template&id=63aed3d7"
import script from "./horizontal-nav.vue?vue&type=script&lang=js"
export * from "./horizontal-nav.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__